/**
 * @generated SignedSource<<d09b203bad6f239e73db022b952a1b41>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueSearch_issueNavigatorProject$data = {
  readonly projectId?: string | null | undefined;
  readonly " $fragmentType": "issueSearch_issueNavigatorProject";
};
export type issueSearch_issueNavigatorProject$key = {
  readonly " $data"?: issueSearch_issueNavigatorProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueSearch_issueNavigatorProject">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "issueSearch_issueNavigatorProject",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "projectId"
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "e90757060ed6001de993039f99771972";

export default node;
